<template>
    <div
        :class="{
            'has-error': hasErrors
        }"
    >
        <label :for="name" class="label-radio" :class="[isChecked ? 'text-black high-contrast:text-yellow-300' : 'text-grey-200 high-contrast:text-yellow-300/75']">
            <span class="mt-1">
                <input
                    type="radio"
                    :name="name"
                    :id="name"
                    :value="name"
                    :checked="isChecked"
                    @change="$emit('input', $event.target.value)"
                />
                <i :class="{'border border-grey-200 rounded-full bg-transparent p-2 high-contrast:border-yellow-300': true, 'border-orange': hasErrors}"></i>
            </span>
            <div class="inline-block font-light radio-text text-1375xl">
                {{ __(label) }}
            </div>
        </label>
        <span
            v-for="(error, index) in inputErrors"
            v-bind:key="`error-${index}`"
            class="validation-error">
                {{ error }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: Number|String,
            required: true
        },
        label: String,
        errors: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        hasValue() {
            return !_.isEmpty(this.value);
        },
        hasErrors() {
            return _.isArray(this.inputErrors) && this.inputErrors.length > 0;
        },
        inputErrors() {
            return _.get(this.errors, this.name, []);
        },
        isChecked() {
            return this.$attrs.value == this.name;
        }
    }
};
</script>
